import React from 'react';
import { useIntl } from 'react-intl';

import { SfaFatalError } from '@futrli/shared-services';

import image from './images/request-approval.svg';

export const SfaUserCannotAccessAllOrgsFatalError = () => {
  const intl = useIntl();

  const text = {
    title: intl.formatMessage({
      id: 'onboarding.sfa.we_could_not_link_to_this_organisation',
      defaultMessage: 'We could not link to this organisation'
    }),
    subtitle: intl.formatMessage({
      id: 'onboarding.sfa.you_do_not_have_permissions_to_link_to_org',
      defaultMessage: 'You do not have the permissions you need to link to this organisation.'
    }),
    text1: intl.formatMessage({
      id: 'onboarding.sfa.you_must_be_admin_user_with_access_to_all_orgs',
      defaultMessage:
        'You must be an Administrator or Super administrator user with access to all organisations to set up this link.'
    }),
    text2: intl.formatMessage({
      id: 'onboarding.sfa.contact_your_futrli_admin',
      defaultMessage:
        'Contact your workspace administrator to ensure you have the permissions you need before you try again.'
    })
  };

  const textBlock = (
    <>
      {text.text1}
      <br />
      <br />
      {text.text2}
    </>
  );

  return <SfaFatalError image={image} {...text} text={textBlock} />;
};
